import { useEffect, useRef } from 'react';

export default function useReveal(options = {}) {
  const ref = useRef(null);
  const optsRef = useRef(options);
  optsRef.current = options;
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    // If already flagged visible in a prior render, keep it (avoids resetting on parent re-render).
    if (el.classList.contains('is-visible')) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px', ...optsRef.current }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return ref;
}
